import { marked } from 'marked';
import TurndownService from 'turndown';
import { gfm } from 'turndown-plugin-gfm';

const turndown = new TurndownService({
  headingStyle: 'atx',
  codeBlockStyle: 'fenced',
  bulletListMarker: '-',
});

turndown.use(gfm);

turndown.addRule('markHighlight', {
  filter: ['mark'],
  replacement: (content) => `==${content}==`,
});

/**
 * About field is stored as Markdown; Tiptap edits HTML. Convert markdown → HTML for the editor.
 */
export function markdownToHtml(md) {
  if (!md || !String(md).trim()) return '<p></p>';
  let s = String(md);
  s = s.replace(/==([^=\n]+)==/g, '<mark>$1</mark>');
  const result = marked.parse(s, { async: false, gfm: true });
  return typeof result === 'string' ? result : '<p></p>';
}

const EMPTY_HTML = /^(<p><\/p>|<p><br\s*\/?><\/p>|<p>\s*<\/p>)$/i;

/**
 * Convert editor HTML back to Markdown for persistence (matches AboutFormattedText / vCard stripper).
 */
export function htmlToMarkdown(html) {
  if (!html || EMPTY_HTML.test(String(html).trim())) return '';
  return turndown.turndown(html).trim();
}
